import {
  useLocation as useLocation,
  Navigate as Navigate,
} from 'react-router';
import { memo as memo } from 'react';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  setDefaultKeyykye56baz645 as setDefaultKey,
  addChildspxcpid5g99g as addChild,
} from '../../../../../../kotlin-react-core/react/ChildrenBuilder.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FCjj9oni2aqo4w as FC } from '../../../../../../kotlin-react/react/FC.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_RedirectUnauthenticated() {
  _init_properties_RedirectUnauthenticated_kt__rbvvco();
  return RedirectUnauthenticated;
}
var RedirectUnauthenticated;
function RedirectUnauthenticated$lambda($this$FC, it) {
  _init_properties_RedirectUnauthenticated_kt__rbvvco();
  var location = useLocation();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$2 = [];
  // Inline function 'kotlin.apply' call
  var this_0 = new URLSearchParams(tmp$ret$2);
  this_0.append('path', location.pathname + '?' + location.search);
  var params = this_0;
  setDefaultKey($this$FC, '@rdk/11_4');
  var tmp2 = Navigate;
  // Inline function 'react.ChildrenBuilder.invoke' call
  var block = ($this$Navigate) => {
    $this$Navigate.to = '/welcome?' + toString(params);
    return Unit_instance;
  };
  addChild($this$FC, tmp2, block);
  return Unit_instance;
}
var properties_initialized_RedirectUnauthenticated_kt_afrbl6;
function _init_properties_RedirectUnauthenticated_kt__rbvvco() {
  if (!properties_initialized_RedirectUnauthenticated_kt_afrbl6) {
    properties_initialized_RedirectUnauthenticated_kt_afrbl6 = true;
    var tmp0 = memo(FC(RedirectUnauthenticated$lambda));
    // Inline function 'seskar.react.internal.withDisplayName' call
    var displayName = 'RedirectUnauthenticated';
    if (process.env.NODE_ENV !== 'production') {
      // Inline function 'kotlin.js.asDynamic' call
      if (!tmp0.displayName) {
        // Inline function 'kotlin.js.asDynamic' call
        tmp0.displayName = displayName;
      }
    }
    RedirectUnauthenticated = tmp0;
  }
}
//region block: exports
export {
  get_RedirectUnauthenticated as get_RedirectUnauthenticated3k2ls39zybq83,
};
//endregion

//# sourceMappingURL=RedirectUnauthenticated.mjs.map
